//@ts-check

/** @type {import('../types').DataType<import('./types').ProjectBasicModel>} */
var CORRESPONDENCE_DATA_TYPE = {
  extends: 'project',
  data: {
    url: '/backend/communications',
    itemUrl: '/backend/communications?uid={id}',
    dataKey: 'correspondences',
    idKeyProp: 'UID',
    filterUrlKey: 'searchName',
    onBeforeRequest: function onBeforeRequest(options, request) {
      if (request.type === 'loadView') {
        return {
          query: {
            communicationType: 'interactive'
          }
        };
      }
    }
  },
  placeholders: {
    type: 'form',
    icon: function icon(data) {
      if (!data) return 'interactive';
      return data.Type;
    }
  }
};
export default CORRESPONDENCE_DATA_TYPE;